import { Routes } from "@angular/router";
import { LoginComponent } from "./components/login.component";
import { ConfirmPasswordComponent } from "./components/confirm-password.component";
import { RecoverPasswordComponent } from "./components/recover-password.component";

export const AUTH_ROUTES: Routes = [
	{
		path: 'auth',
		children: [
			{ path: 'login', component: LoginComponent },
            //{ path: 'confirm-password/:token', component: ConfirmPasswordComponent },
            { path: 'confirm-password', component: ConfirmPasswordComponent },
			{ path: 'recover-password', component: RecoverPasswordComponent }
		]
	}
];
